import Vue from "vue"
import { ObserveVisibility } from "vue-observe-visibility"

Vue.directive('vis-change', ObserveVisibility)